import { RwdSvgIcon } from '@/components/common/rwdSvgIcon/RwdSvgIcon';
import { BalanceContext } from '@/contexts/BalanceContext';
import { ScreenContext } from '@/contexts/ScreenContext';
import { useIsLobby } from '@/hooks/useIsLobby';
import { IcoWallet } from '@/modules/common/svg';
import { FONT_SIZE } from '@/modules/rwdGame/components/GameInfoPanel/BalanceInfo';
import { RwdSvgIcon as NewRwdSvgIcon } from '@/modules/rwdGame/components/RwdSvgIcon/RwdSvgIcon';
import { RwdTypography } from '@/modules/rwdGame/components/RwdTypography';
import { getVHByRem } from '@/utils/commonFunc';
import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useContext, useEffect, useState } from 'react';
import './DisplayBalance.scss';
import { RefreshBalance } from './RefreshBalance';
type DisplayBalanceProps = {
    hideRefresh?: boolean;
};
export const DisplayBalance = ({
    hideRefresh = false,
}: DisplayBalanceProps) => {
    const { isLandscape } = useContext(ScreenContext);
    const [iconSize, setIconSize] = useState<string>('1.1rem');
    const [refreshIconSize, setRefreshIconSize] = useState<string>('1.5rem');
    const [fontSize, setFontSize] = useState<
        string | { xs: string; md: string; lg: string }
    >(FONT_SIZE);
    const isLobby = useIsLobby();

    useEffect(() => {
        setIconSize(isLandscape ? getVHByRem(1) : '1.1rem');
        setRefreshIconSize(isLandscape ? getVHByRem(1.5) : '1.5rem');
        setFontSize(isLandscape ? getVHByRem(1.02) : FONT_SIZE);
    }, [isLandscape]);

    const { displayBalance, currency } = useContext(BalanceContext);
    return (
        <>
            {isLobby && (
                <Box
                    className="display-balance-lobby-container"
                    height={iconSize}
                >
                    <Box width={iconSize} height={iconSize} display={'flex'}>
                        <IcoWallet />
                    </Box>
                    <Stack
                        direction={'row'}
                        className="my-auto"
                        spacing={0.5}
                        display={'flex'}
                        alignItems="flex-end"
                    >
                        <Typography
                            whiteSpace={'nowrap'}
                            fontSize={fontSize}
                            lineHeight={1}
                        >
                            {displayBalance} {currency}
                        </Typography>
                    </Stack>
                    {!hideRefresh && (
                        <Box
                            width={refreshIconSize}
                            height={refreshIconSize}
                            display={'flex'}
                            alignItems={'center'}
                            // margin={`0 ${isLandscape ? getVHByRem(0.2) : '0.2rem'}`}
                        >
                            <RwdSvgIcon vSize={1.5} hSize={getVHByRem(1.5)}>
                                <RefreshBalance
                                    width={'100%'}
                                    height={'100%'}
                                    className="refresh-button"
                                />
                            </RwdSvgIcon>
                        </Box>
                    )}
                </Box>
            )}
            {!isLobby && (
                <Box className="display-balance-in-game-container">
                    <IcoWallet className="ico-wallet" />
                    <RwdTypography stepIndex={3} landscapeStepIndex={4}>
                        {displayBalance} {currency}
                    </RwdTypography>
                    {!hideRefresh && (
                        <NewRwdSvgIcon
                            portraitIconSize={32}
                            landscapeIconSize={48}
                        >
                            <RefreshBalance />
                        </NewRwdSvgIcon>
                    )}
                </Box>
            )}
        </>
    );
};
